import { createTheme } from "@mui/material";

export const palette1 = {
  primary: { light: "#cbd78d", main: "#768459", dark: "#2c2f24" },
  secondary: { light: "#eee3a3", main: "#fa691a", dark: "#c24704" },
  yellow: { light: "#FFFEA9", main: "#fbdf46", dark: "#f7bd4d" }, //yello
  //error: {main: "#e53935"},//rouge foncé
  error: { main: "rgba(255, 0, 0, 0.6)" }, //rouge foncé
  //success: {main: "#388e3c"},//vert
  success: { main: "rgba(46, 125, 50,0.7)" }, //vert
  bleu: { light: "#c5cae9", main: "#3f51b5", dark: "#0e073a" },
  background: { default: "#F4F6F8" },
};
export const palette2 = {
  primary: {
    light: "#b6d0f2",
    main: "#4e6eaa",
    dark: "#1d2c45",
  },
  secondary: {
    light: "#ffd8cb",
    main: "#ff6b4a",
    dark: "#a13c28",
  },
  yellow: { light: "#FFFEA9", main: "#fbdf46", dark: "#f7bd4d" }, //yello
  //error: {main: "#e53935"},//rouge foncé
  error: { main: "rgba(255, 0, 0, 0.6)" }, //rouge foncé
  //success: {main: "#388e3c"},//vert
  success: { main: "rgba(46, 125, 50,0.7)" }, //vert
  bleu: { light: "#c5cae9", main: "#3f51b5", dark: "#0e073a" },
  background: { default: "#F4F6F8" },
};

export const createAppTheme = (usePalette1) => {
  const palette = usePalette1 ? palette1 : palette2;
  return createTheme({
    palette: palette,
    typography: {
      fontFamily: "Inter, sans-serif",
      fontOpticalSizing: "auto",
      fontWeight: 400,
      fontVariantNumeric: "tabular-nums",
      fontStyle: "normal",
      button: {
        fontSize: 12,
        fontWeight: "bold",
      },
      h6: {
        fontSize: "16px",
        fontWeight: "600",
      },
    },

    zIndex: {
      mobilestepper: 1000,
      fab: 1050,
      speeddial: 1050,
      appbar: 1100,
      drawer: 1200,
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500,
    },
    components: {
      MuiIconButton: {
        styleOverrides: {
          root: {
            "&.MuiIconButton-edgeEnd": {
              marginRight: "0px",
              "& .MuiSvgIcon-root": {
                fontSize: "20px", // smaller icon
              },
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            "& .MuiChip-root": {
              height: 18, // make chip smaller
              fontSize: "0.7rem",
              margin: "1px",
              marginRight: "4px !important",
              "& .MuiChip-label": {
                padding: "0 4px",
                paddingRight: "4px",
              },
              "& .MuiChip-deleteIcon": {
                fontSize: "18px",
                marginLeft: 0,
              },
            },
            "& .MuiAutocomplete-tag": {
              margin: 0,
            },
            "& .MuiInputBase-root": {
              minHeight: 23, // set the input field height
              paddingTop: 0,
              paddingBottom: 0,
              marginRight: "2px",
            },
          },
        },
      },
      MuiAccordion: {
        defaultProps: {
          // Set default props
          disableGutters: true,
          square: false,
          elevation: 0,
        },
        styleOverrides: {
          root: {
            // Main accordion container
            border: "1px solid #ddd",
            marginBottom: "0px",
            "&.Mui-expanded": {
              margin: "auto",
              marginBottom: "8px",
              marginTop: "8px",
            },
          },
          // expanded: {
          //   // Specific override when expanded
          //   margin: 'auto',
          // },
        },
      },

      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            minHeight: "35px",
            height: "35px",
            "&.Mui-expanded": {
              minHeight: "35px",
            },
          },
          content: {
            margin: "12px 0",
            "&.Mui-expanded": {
              margin: "12px 0",
            },
          },
          expandIconWrapper: {
            color: "#333",
            "&.Mui-expanded": {
              transform: "rotate(180deg)",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            height: "fit-content !important",
          },
        },
      },

      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            padding: "0px",
            //backgroundColor: '#fafafa',
            borderTop: "1px solid #ddd",
            borderRadius: "8px",
          },
        },
      },

      MuiTableContainer: {
        root: {
          height: "400px !important", // Changer la hauteur selon vos besoins
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            // height: '24px !important', // Set the desired height here
            fontSize: "16px",
            padding: "0 !important",
            paddingLeft: "10px !important",
            MuiIconButton: {
              padding: "0px",
              //itried this
              marginRight: "-6px",
            },
          },
          input: {
            // height: '32px !important',
            margin: "2px !important",
            padding: " 0px 0px !important",
            paddingLeft: " 8px",
            backgroundColor: "white !important",
            fontSize: "13px",
          },
        },
      },

      MuiInputLabel: {
        styleOverrides: {
          outlined: {
            top: "-13px !important",
            fontSize: "12px",
          },
          shrink: {
            transform: "translate(14px, 3px) scale(0.75)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            height: "28px", // Adjust the height of buttons
            padding: "8px 8px !important",
          },
          contained: {
            "&.MuiButton-containedSecondary": {
              color: "#fff",
            },
          },
        },
        variants: [
          {
            props: { color: "primary" },
            style: {
              "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.light + " !important",
              },
            },
          },
        ],
      },

      MuiFormControl: {
        styleOverrides: {
          root: {
            backgroundColor: "white !important", ///fella
            marginTop: "0px",
            marginBottom: "0px",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            overflow: "hidden !important",
            borderRadius: "8px",
            maxWidth: "none !important", // Adjust the max width as needed
            maxHeight: "100vh",
            background: "var(--dt-row-bg)",
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            backgroundColor: "var(--body-bg)",
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            background: palette.primary.dark,
            height: "30px",
            padding: "8px 16px",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between ",
          },
        },
        title: {
          flex: "1",
          textAlign: "center",
          margin: "auto", // Set margin to auto
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            background: "var(--body-bg)",
            padding: "16px 24px !important",
            color: "black",
            display: "flex",
            alignItems: "center",

            //justifyContent:'center' ////fella
          },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            background: "var(--body-bg) !important",
            "&::before": {
              background: "var(--body-bg) !important",
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            background: "var(--dt-row-bg)",
            borderRadius: "var(---globalborder-radius)", // Adjust the border radius for Paper components
          },
        },
      },

      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: "#999 ",
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fill: "#999 ",
          },
        },
      },

      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: "12px", // added by fella
          },
        },
      },

      MuiCardMedia: {
        styleOverrides: {
          root: {
            display: "flex",
            backgroundsize: "cover",
            backgroundrepeat: "no-repeat",
            backgroundposition: " center", // added by fella
          },
        },
      },

      MuiAppBar: {
        styleOverrides: {
          root: {
            borderRadius: "8px", // Adjust the border radius for App Bar
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "8px", // Adjust the border radius for Cards
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "9px",
          },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            MuiButton: {
              root: {
                lineheight: "0 !important",
                alignItems: "center",
              },
            },
          },
        },
      },
      MuiPickersLayout: {
        styleOverrides: {
          root: ({ theme }) => ({
            transformOrigin: "top left",
            width: "100%",
            [theme.breakpoints.down("sm")]: {
              //  transform: "scale(0.8)",
            },
          }),
        },
      },
      MuiDateCalendar: {
        styleOverrides: {
          root: ({ theme }) => ({
            width: "100%",

            [theme.breakpoints.down("sm")]: {
              width: "100%",
            },
          }),
        },
      },

      MuiPickersCalendarHeader: {
        styleOverrides: {
          label: ({ theme }) => ({
            fontSize: "14px",

            [theme.breakpoints.down("sm")]: {
              fontSize: "12px",
            },
          }),
        },
      },
      MuiPickersToolbar: {
        styleOverrides: {
          root: ({ theme }) => ({
            [theme.breakpoints.down("sm")]: {
              minHeight: "48px",
            },
          }),
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: ({ theme }) => ({
            [theme.breakpoints.down("sm")]: {
              minHeight: 32,
            },
          }),

          scroller: {
            height: "auto",
          },

          flexContainer: {
            gap: 0,
          },

          indicator: {
            height: 2,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: ({ theme }) => ({
            [theme.breakpoints.down("sm")]: {
              minHeight: 30,
              padding: "2px 6px",
              fontSize: "11px",
            },
          }),
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE/Edge
          },

          "*::-webkit-scrollbar": {
            width: 0,
            height: 0,
            display: "none",
          },
        },
      },
    },
    overrides: {
      MuiButton: {
        root: {
          height: "32px", // Adjust the height of buttons
        },
      },
      MuiAutocomplete: {
        root: {
          padding: "0",
          paddingLeft: "10px !important",
          width: "50px !important",
        },
        MuiPopper: {
          styleOverrides: {
            popper: {
              width: "max-content !important",
            },
          },
        },
        option: {
          background: "white !important",
          '&[data-focus="true"]': {
            backgroundColor: "#eee !important",
          },
        },
        tag: {
          margin: "6px",
        },
      },

      MuiOutlinedInput: {
        root: {
          height: "24px !important", // Set the desired height here
          fontSize: "16px",
          padding: "0 ",
          paddingLeft: "10px !important",
        },
        input: {
          margin: "2px !important",
          padding: " 2px 0px !important",
          paddingLeft: " 8px !important",
        },
      },
      MuiInputLabel: {
        outlined: {
          top: "-12px !important",
        },
        shrink: {
          transform: "translate(14px, 0px) scale(0.75)",
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "9px",
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          MuiTableCell: {
            backgroundColor: palette.primary,
          },
        },
      },
    },
  });
};
